<template>
  <v-menu offset-y nudge-top="-20" v-if="($route.name != 'extra' && requests_routes) || request_details_route">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" height="32px" width="50px" style="min-width: unset" class="ml-5 mr-3 p-0"
        color="#FFFFFF" depressed>
        <v-icon color="#3F0E40" size="40">mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list v-if="
      request_details_route &&
      ($store.state.quality_request_info.quality_status == 0 ||
        $store.state.quality_request_info.quality_status == 1 ||
        $store.state.quality_request_info.quality_status == 2 ||
        $store.state.quality_request_info.quality_status == 5)
    ">
      <v-list-item class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed"
        @click="move_request_to_followed" :disabled="$store.state.quality_request_info.is_followed == 1">
        <v-list-item-icon class="ml-3">
          <svg id="Group_11469" data-name="Group 11469" xmlns="http://www.w3.org/2000/svg" width="18.284" height="19.02"
            viewBox="0 0 18.284 19.02">
            <path id="Path_4001" data-name="Path 4001"
              d="M288.5,245.158l-8.952,5.168-.194.112-.191-.115-8.571-5.168.392-.651,8.38,5.053,8.758-5.056Z"
              transform="translate(-270.411 -244.449)"
              :fill="$store.getters.isDark ? '#fff' : '#2c2c2c'"
            />
            <path
              id="Path_4002"
              data-name="Path 4002"
              d="M255.474,240.125h17.9v10.149h-11.5l.174-.174a1.621,1.621,0,0,0,.284-.384,1.66,1.66,0,0,0,.091-.2h10.194v-8.627H255.854v8.627h.357a7,7,0,0,0,.2.761h-1.315V240.125h.38Z"
              transform="translate(-255.093 -240.125)"
              :fill="$store.getters.isDark ? '#fff' : '#2c2c2c'"
            />
            <path
              id="Path_4003"
              data-name="Path 4003"
              d="M386.083,659.276a1.03,1.03,0,0,1-.046.479,1.072,1.072,0,0,1-.26.407h0l-1.875,1.861a1.308,1.308,0,0,1-.206.184,1.607,1.607,0,0,1-.244.144,1.9,1.9,0,0,1-.255.1,1.632,1.632,0,0,1-.261.06l-.051,0h0s0,0,0,0l-.051,0q-.045,0-.105.007l-.116,0c-2.1,0-4.461-1.358-6.428-3.2-2.17-2.03-3.874-4.667-4.2-6.715q-.031-.2-.047-.36t-.017-.307h0v-.011h0c0-.023,0-.04,0-.054s0-.046,0-.052c.006-.105.009-.171.011-.2s0-.05,0-.067l0-.053a1.631,1.631,0,0,1,.06-.261,1.906,1.906,0,0,1,.1-.255,1.6,1.6,0,0,1,.144-.244,1.312,1.312,0,0,1,.17-.193h0l1.889-1.889a1.074,1.074,0,0,1,.33-.228.971.971,0,0,1,.393-.082h0a.938.938,0,0,1,.291.044.9.9,0,0,1,.263.138,1.341,1.341,0,0,1,.183.165,1.4,1.4,0,0,1,.15.2l.016.027,1.515,2.874h0a1.053,1.053,0,0,1,.126.37,1.115,1.115,0,0,1-.015.39,1.321,1.321,0,0,1-.124.35,1.241,1.241,0,0,1-.22.3h0l-.643.643a1.744,1.744,0,0,0,.055.17,2.98,2.98,0,0,0,.146.321v0a8.073,8.073,0,0,0,1.452,1.875,8.228,8.228,0,0,0,1.881,1.465h0q.159.081.263.123a.887.887,0,0,0,.15.048l.073.015.754-.767.018-.018a1.253,1.253,0,0,1,.849-.324,1.372,1.372,0,0,1,.3.032.942.942,0,0,1,.263.1l.029.008,2.741,1.619.006,0a1.243,1.243,0,0,1,.342.3,1,1,0,0,1,.187.414l0,.025Zm-.763.229a.271.271,0,0,0,.013-.11.254.254,0,0,0-.047-.1.479.479,0,0,0-.128-.112h0l-2.731-1.613-.025-.007a.185.185,0,0,0-.054-.019.651.651,0,0,0-.135-.011.488.488,0,0,0-.341.129l-.794.808h0a.535.535,0,0,1-.126.094.729.729,0,0,1-.116.048q-.057.019-.089.026a.548.548,0,0,1-.122.016l-.074-.007-.177-.035a1.638,1.638,0,0,1-.283-.09q-.151-.061-.326-.15v0a8.983,8.983,0,0,1-2.075-1.6,8.832,8.832,0,0,1-1.59-2.067h0a3.705,3.705,0,0,1-.181-.4,2.332,2.332,0,0,1-.11-.382l-.007-.07a.624.624,0,0,1,.013-.122.915.915,0,0,1,.029-.1.734.734,0,0,1,.048-.116.54.54,0,0,1,.092-.125h0l.7-.7h0a.48.48,0,0,0,.084-.115.558.558,0,0,0,.053-.147.369.369,0,0,0,.006-.128.3.3,0,0,0-.037-.106l0-.009-1.514-2.873a.663.663,0,0,0-.059-.074.583.583,0,0,0-.079-.073.143.143,0,0,0-.043-.022.184.184,0,0,0-.057-.009v0a.222.222,0,0,0-.09.017.326.326,0,0,0-.1.07l-1.889,1.889-.015.013a.549.549,0,0,0-.078.088.84.84,0,0,0-.076.128,1.143,1.143,0,0,0-.061.154.915.915,0,0,0-.03.122l0,.067c0,.07-.007.137-.011.2l0,.031q0,.016,0,.033h0v.011h0q0,.1.014.235t.041.312c.3,1.888,1.91,4.357,3.967,6.281,1.839,1.721,4.02,2.99,5.911,2.99h.09l.058,0,.063-.007.026,0a.917.917,0,0,0,.12-.03,1.154,1.154,0,0,0,.154-.061.845.845,0,0,0,.128-.076.561.561,0,0,0,.088-.078l.015-.015,1.888-1.874h0A.327.327,0,0,0,385.321,659.505Zm-2.437,3.011h0Z"
              transform="translate(-370.53 -643.511)"
              :fill="$store.getters.isDark ? '#fff' : '#2c2c2c'"
            />
          </svg>
        </v-list-item-icon>
        <v-list-item-title> تحويل الطلب للمتابعة</v-list-item-title>
      </v-list-item>

      <v-list-item @click="add_needToBeTurnedReq" v-if="
        ($store.state.quality_request_info.quality_status != 5 &&
          $store.state.quality_request_info.quality_status != 3) || !returnWindowPlace
      " class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed">
        <v-list-item-icon class="ml-2"><v-icon style="font-size: 25px">mdi-refresh</v-icon></v-list-item-icon>
        <!-- <v-list-item-title> ارشفة الطلب</v-list-item-title> -->
        <v-list-item-title> إضافة الطلب لسلة التحويل</v-list-item-title>
      </v-list-item>

      <v-list-item @click="save_Request" class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed">
        <v-list-item-icon class="ml-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="19.55" height="19.55" viewBox="0 0 19.55 19.55">
            <g id="Icon_feather-save" data-name="Icon feather-save" transform="translate(-4 -4)">
              <path id="Path_4006" data-name="Path 4006"
                d="M20.989,23.05H6.561A2.061,2.061,0,0,1,4.5,20.989V6.561A2.061,2.061,0,0,1,6.561,4.5H17.9L23.05,9.653V20.989A2.061,2.061,0,0,1,20.989,23.05Z"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4007"
                data-name="Path 4007"
                d="M20.805,27.744V19.5H10.5v8.244"
                transform="translate(-1.878 -4.695)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4008"
                data-name="Path 4008"
                d="M10.5,4.5V9.653h8.244"
                transform="translate(-1.878)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>حفظ الطلب</v-list-item-title>
      </v-list-item>

      <v-list-item @click="move_request_to_notcomplete" class="black--text font-weight-bold">
        <v-list-item-icon class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.227"
            height="20.227"
            viewBox="0 0 20.227 20.227"
          >
            <g
              id="Icon_feather-send"
              data-name="Icon feather-send"
              transform="translate(-2.5 -2.293)"
            >
              <path
                id="Path_4004"
                data-name="Path 4004"
                d="M26.961,3,16.5,13.461"
                transform="translate(-4.941)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4005"
                data-name="Path 4005"
                d="M22.02,3,15.363,22.02l-3.8-8.559L3,9.657Z"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>طلب غير مكتمل</v-list-item-title>
      </v-list-item>

      <v-list-item @click="move_request_to_complete" class="black--text font-weight-bold">
        <v-list-item-icon class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.227"
            height="20.227"
            viewBox="0 0 20.227 20.227"
          >
            <g
              id="Icon_feather-send"
              data-name="Icon feather-send"
              transform="translate(-2.5 -2.293)"
            >
              <path
                id="Path_4004"
                data-name="Path 4004"
                d="M26.961,3,16.5,13.461"
                transform="translate(-4.941)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4005"
                data-name="Path 4005"
                d="M22.02,3,15.363,22.02l-3.8-8.559L3,9.657Z"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-list-item-icon>
        <v-list-item-title> طلب مكتمل</v-list-item-title>
      </v-list-item>

      <v-list-item @click="open_questions_dialog">
        <v-list-item-icon class="ml-3">
          <img src="@/assets/icons/rateQuation.svg" />
        </v-list-item-icon>
        <v-list-item-title>اسئلة التقييم</v-list-item-title>
      </v-list-item>

    </v-list>
    <v-list v-else>
      <v-list-item @click="add_needToBeTurnedReq" v-if="
        ($store.state.quality_request_info.quality_status != 5 &&
          $store.state.quality_request_info.quality_status != 3) || !returnWindowPlace
      " class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed">
        <v-list-item-icon class="ml-2"><v-icon style="font-size: 25px">mdi-refresh</v-icon></v-list-item-icon>
        <!-- <v-list-item-title> ارشفة الطلب</v-list-item-title> -->
        <v-list-item-title> إضافة الطلب لسلة التحويل</v-list-item-title>
      </v-list-item>

      <v-list-item :disabled="true" class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed">
        <v-list-item-icon class="ml-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="19.55" height="19.55" viewBox="0 0 19.55 19.55">
            <g id="Icon_feather-save" data-name="Icon feather-save" transform="translate(-4 -4)">
              <path id="Path_4006" data-name="Path 4006"
                d="M20.989,23.05H6.561A2.061,2.061,0,0,1,4.5,20.989V6.561A2.061,2.061,0,0,1,6.561,4.5H17.9L23.05,9.653V20.989A2.061,2.061,0,0,1,20.989,23.05Z"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4007"
                data-name="Path 4007"
                d="M20.805,27.744V19.5H10.5v8.244"
                transform="translate(-1.878 -4.695)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4008"
                data-name="Path 4008"
                d="M10.5,4.5V9.653h8.244"
                transform="translate(-1.878)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>حفظ الطلب</v-list-item-title>
      </v-list-item>

      <v-list-item :disabled="true" class="black--text font-weight-bold">
        <v-list-item-icon class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.227"
            height="20.227"
            viewBox="0 0 20.227 20.227"
          >
            <g
              id="Icon_feather-send"
              data-name="Icon feather-send"
              transform="translate(-2.5 -2.293)"
            >
              <path
                id="Path_4004"
                data-name="Path 4004"
                d="M26.961,3,16.5,13.461"
                transform="translate(-4.941)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4005"
                data-name="Path 4005"
                d="M22.02,3,15.363,22.02l-3.8-8.559L3,9.657Z"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-list-item-icon>
        <v-list-item-title>طلب غير مكتمل</v-list-item-title>
      </v-list-item>

      <v-list-item :disabled="true" class="black--text font-weight-bold">
        <v-list-item-icon class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.227"
            height="20.227"
            viewBox="0 0 20.227 20.227"
          >
            <g
              id="Icon_feather-send"
              data-name="Icon feather-send"
              transform="translate(-2.5 -2.293)"
            >
              <path
                id="Path_4004"
                data-name="Path 4004"
                d="M26.961,3,16.5,13.461"
                transform="translate(-4.941)"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4005"
                data-name="Path 4005"
                d="M22.02,3,15.363,22.02l-3.8-8.559L3,9.657Z"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-list-item-icon>
        <v-list-item-title> طلب مكتمل</v-list-item-title>
      </v-list-item>

      <v-list-item @click="open_questions_dialog">
        <v-list-item-icon class="ml-3">
          <img src="@/assets/icons/rateQuation.svg" />
        </v-list-item-icon>
        <v-list-item-title>اسئلة التقييم</v-list-item-title>
      </v-list-item>

    </v-list>
  </v-menu>
</template>

<script>
import Axios from "axios";
export default {
  name: "ReciveIcon",

  data() {
    return {
      url:
        `${this.$store.state.url}/v2/employee/ConvertRequestToFollowedOrStared`,
    };
  },

  computed: {
    request_details_route() {
      return (
        this.$route.name == "quality_agent_data" ||
        this.$route.name == "quality_real_estate_data" ||
        this.$route.name == "quality_fund_data" ||
        this.$route.name == "quality_fund_calc" ||
        this.$route.name == "quality_attachments" ||
        this.$route.name == "quality_logs" ||
        this.$route.name == "quality_tickets" ||
        this.$route.name == "quality_prepayment" ||
        this.$route.name == "quality_request_details"
      );
    },
    requests_routes() {
      return (
        this.$route.name == "quality_all" ||
        this.$route.name == "quality_recieved" ||
        this.$route.name == "quality_following" ||
        this.$route.name == "quality_special" ||
        this.$route.name == "quality_archieved" ||
        this.$route.name == "quality_special" ||
        this.$route.name == "quality_completed" ||
        this.$route.name == "quality_buying" ||
        this.$route.name == "quality_extra"
      );
    },

    returnWindowPlace() {
      return window.location.pathname === "/quality/requests/completed";
    },
  },

  methods: {
    move_request_to_followed() {
      let req_id = "";
      req_id = this.$route.params.id;
      const formData = new FormData();
      formData.append("request_ids[]", req_id);
      Axios.get(
        `${this.$store.state.url}/employee/quality/request-details-followed/${req_id}`,
        //   formData,
        {
          headers: this.request_headers(),
        }
      )
        .then(() => {
          this.showPopup("success", "تم تحويل الطلب للمتابعة");
          setTimeout(() => {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }, 2000);
        })

        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },
    move_request_to_notcomplete() {
      let req_id = "";
      req_id = this.$route.params.id;
      const formData = new FormData();
      formData.append("request_ids[]", req_id);
      Axios.get(
        `${this.$store.state.url}/employee/quality/request-details-not-complete/${req_id}`,
        //   formData,
        {
          headers: this.request_headers(),
        }
      )
        .then(() => {
          this.showPopup("success", "تم تحويل الطلب لغير مكتمل");
          setTimeout(() => {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }, 2000);
        })

        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },
    move_request_to_complete() {
      let req_id = "";
      req_id = this.$route.params.id;
      // const formData = new FormData();
      // formData.append("request_ids[]", req_id);
      Axios.get(
        `${this.$store.state.url}/employee/quality/request-details-complete/${req_id}`,
        //   formData,
        {
          headers: this.request_headers(),
        }
      )
        .then(() => {
          this.showPopup("success", "تم تحويل الطلب لمكتمل");
          setTimeout(() => {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }, 2000);
        })

        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },
    move_request_to_archive() {
      let req_id = "";
      req_id = this.$route.params.id;
      // const formData = new FormData();
      // formData.append("request_ids[]", req_id);
      Axios.get(
        `${this.$store.state.url}/employee/quality/request-details-archive/${req_id}`,
        //   formData,
        {
          headers: this.request_headers(),
        }
      )
        .then(() => {
          this.showPopup("success", "تم ارشفة الطلب");
          setTimeout(() => {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }, 2000);
        })

        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },
    // add_needToBeTurnedReq() {
    //   let req_id = "";
    //   req_id = this.$route.params.id;
    //   // const formData = new FormData();
    //   // formData.append("request_ids[]", req_id);
    //   Axios.get(
    //     `${this.$store.state.url}/employee/quality/addNeedToBeTurnedReq/${req_id}`,
    //     //   formData,
    //     {
    //       headers: this.request_headers(),
    //     }
    //   )
    //     .then(() => {
    //       this.showPopup("success", "تم إضافة الطلب لسلة التحويل");
    //       setTimeout(() => {
    //         this.loading = true;
    //         setTimeout(() => {
    //           this.loading = false;
    //         }, 1000);
    //       }, 2000);
    //     })

    //     .catch((err) => {
    //       this.showPopup("error", err.response.data.message);
    //     });
    // },


    add_needToBeTurnedReq() {
      const quacomment = this.$store.state.request_info?.quacomment || "";
      this.$root.$emit("OPEN_TRANSFER_BASKET_DIALOG", this.$route.params.id, quacomment);
    },

    open_questions_dialog() {
      console.log('this.id is from another ' + this.$route.params.id);
      this.$store.state.QualityQuestionsDialogReqId = this.$route.params.id;
      this.$store.state.QualityQuestionsDialog = true;
    },

    save_Request() {
      this.saveErrs = {
        alert: false,
        error: [],
      };
      let payload = this.$store.state.request_info;
      let quality_id = this.$store.state.quality_request_info.id;
      let update_request = {
        id: parseInt(quality_id),
        request_id: parseInt(payload.id),
        customerName: payload.customer.name,
        sex: payload.customer.sex,
        birth_date: payload.customer.birth_date,
        birth_date_higri: payload.customer.birth_date_higri,
        age: payload.customer.age,
        age_years: payload.customer.age_years,
        work: payload.customer.work,
        madany_id: !payload.customer.askary_id
          ? parseInt(payload.customer.madany_id)
          : undefined,
        job_title: payload.customer.job_title,
        askary_id: !payload.customer.madany_id
          ? parseInt(payload.customer.askary_id)
          : undefined,
        military_rank: payload.customer.military_rank,
        hiring_date: payload.customer.hiring_date,

        salary: payload.customer.salary,
        salary_id: parseInt(payload.customer.salary_id),
        is_supported: payload.customer.is_supported,
        nationality_id: payload.customer.nationality_id,
        you_have: payload.customer.you_have,
        source_of_income: payload.customer.source_of_income,
        have_salary: payload.customer.have_salary,

        basic_salary: payload.customer.basic_salary,
        without_transfer_salary: payload.customer.without_transfer_salary,
        add_support_installment_to_salary:
          payload.customer.add_support_installment_to_salary,
        guarantees: parseInt(payload.customer.guarantees),
        has_obligations: payload.customer.has_obligations,
        obligations_value: payload.customer.obligations_value,
        has_financial_distress: payload.customer.has_financial_distress,
        financial_distress_value: payload.customer.financial_distress_value,
        jointName: payload.joint.name,
        jointMobile: payload.joint.mobile,
        jointSalary: payload.joint.salary,
        jointbirth: payload.joint.birth_date,
        jointBirth_higri: payload.joint.birth_date_higri,
        jointAge: payload.joint.age,
        jointage_years: payload.joint.age_years,
        jointWork: payload.joint.work,
        joint_hiring_date: payload.joint.hiring_date,
        jointmadanyWork: !payload.joint.jointaskaryWork
          ? parseInt(payload.joint.madany_id)
          : undefined,
        jointJobTitle: payload.joint.job_title,
        jointaskaryWork: !payload.joint.jointmadanyWork
          ? parseInt(payload.joint.askary_id)
          : undefined,
        jointRank: payload.joint.military_rank,
        jointsalary_source: parseInt(payload.joint.salary_id),
        jointSupport: payload.joint.is_supported,
        joint_add_support_installment_to_salary:
          payload.joint.add_support_installment_to_salary,
        jointObligations: payload.joint.has_obligations,
        jointobligations_value: payload.joint.obligations_value,
        jointfunding_source: parseInt(payload.joint.funding_id),
        realName: payload.real_estate.name,
        realMobile: payload.real_estate.mobile,
        realCity: payload.real_estate.city,
        project_id: payload.real_estate.project_id,
        realRegion: payload.real_estate.region,
        realPursuit: payload.real_estate.pursuit,
        realStatus: payload.real_estate.status,
        realAge: payload.real_estate.age,
        residence_type: payload.real_estate.residence_type,
        realType: payload.real_estate.type,
        realCost: payload.real_estate.cost,
        owning_property: payload.real_estate.owning_property,
        has_property: payload.real_estate.has_property,
        evaluated: payload.real_estate.evaluated,
        tenant: payload.real_estate.tenant,
        mortgage: payload.real_estate.mortgage,
        product_type: payload.funding.product_code,
        funding_source: payload.funding.funding_source,
        fundDur: payload.funding.funding_duration,
        fundPers: payload.funding.personalFun_cost,
        fundPersPre: payload.funding.personalFun_pre,
        fundReal: payload.funding.realFun_cost,
        fundRealPre: payload.funding.realFun_pre,
        fundFlex: payload.funding.flexiableFun_cost,
        fundExten: payload.funding.extendFund_cost,
        personal_salary_deduction: payload.funding.personal_salary_deduction,
        personal_installment: payload.funding.personal_monthly_installment,
        fundDed: payload.funding.ded_pre,
        fundMonth: payload.funding.monthly_in,
        installment_after_support: payload.funding.monthly_installment_after_support,
        reqtyp: payload.type,
        follow_date: payload.follow_date,
        follow_time: payload.follow_time
          ? payload.follow_time.length == 8
            ? payload.follow_time
            : payload.follow_time + ":00"
          : undefined,
        reqSource: payload.source,
        req_product_type: payload.req_product_type,
        agent_identity_number: payload.agent_identity_number,
        class_agent: parseInt(payload.class_id_agent),
        rejection_id_agent: parseInt(payload.rejection_id_agent),
        collaborator_id: parseInt(payload.collaborator_id),
        quality_comment: payload.quacomment,
        class_quality: payload.class_id_quality,
        // comment: payload.agent_notes,
        comment: payload.comment,
        customer_service_note: payload.customer_service_note,
        funding_manager_note: payload.funding_manager_note,
        // prepayment
        PrePrealCost:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.realCost
            : "",
        incValue:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.incValue
            : "",
        preValue:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.prepaymentVal
            : "",
        prePresent:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.prepaymentPre
            : "",
        preCost:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.prepaymentCos
            : "",
        preVisa:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.visa
            : "",
        carLo:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.carLo
            : "",
        personalLo:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.personalLo
            : "",
        realLo:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.realLo
            : "",
        credBank:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.credit
            : "",
        netCust:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.netCustomer
            : "",
        otherLo:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.other
            : "",
        debt:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.debt
            : "",
        morPresnt:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.mortPre
            : "",
        mortCost:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.mortCost
            : "",
        pursitPresnt:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.proftPre
            : "",
        deficitCust:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.deficitCustomer
            : "",
        profCost:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.profCost
            : "",
        addedValue:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.addedVal
            : "",
        adminFees:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.adminFee
            : "",
        realDisposition:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.Real_estate_disposition_value
            : "",
        purchaseTax:
          payload.prepayments !== undefined && payload.prepayments != null
            ? payload.prepayments.purchase_tax_value
            : "",
        // Real_estate_disposition_value: payload.prepayments.Real_estate_disposition_value,
        // purchase_tax_value: payload.prepayments.purchase_tax_value,
        /*
        
        real: payload.prepayments.realCost,
        incr: payload.prepayments.incValue,
        preval: payload.prepayments.prepaymentVal,
        prepre: payload.prepayments.prepaymentPre,
        precos: payload.prepayments.prepaymentCos,
        net: payload.prepayments.netCustomer,
        deficit: payload.prepayments.deficitCustomer,
        visa: payload.prepayments.visa,
        carlo: payload.prepayments.carLo,
        perlo: payload.prepayments.personalLo,
        realo: payload.prepayments.realLo,
        credban: payload.prepayments.credit,
        // Real_estate_disposition_value: payload.prepayments.Real_estate_disposition_value,
        // purchase_tax_value: payload.prepayments.purchase_tax_value,
        other1: payload.prepayments.other,
        debt: payload.prepayments.debt,
        morpre: payload.prepayments.mortPre,
        morcos: payload.prepayments.mortCost,
        propre: payload.prepayments.proftPre,
        procos: payload.prepayments.profCost,
        valadd: payload.prepayments.addedVal,
        admfe: payload.prepayments.adminFee,
        */
      };
      let update_payload = {};
      for (const prop in update_request) {
        if (update_request[prop] != null) {
          update_payload[prop] = update_request[prop];
        }
      }

      Axios.post(
        `${this.$store.state.url}/v2/employee/Requests`,
        update_payload,
        { headers: this.request_headers() }
      )
        .then((res) => {
          // this.showPopup("success", "تم تعديل الطلب بنجاح");
          this.showPopup("success", res.data.message);
        })
        .catch((err) => {
          // work here
          //this.saveErrs.error = err.response.data.message;
          // this.showPopupError("success", err.response.data.message[0].split(","));
          const msg = err.response?.data?.message;
          if (Array.isArray(msg)) {
            this.showPopupError("error", err.response.data.message[0].split(","));
          } else if (typeof msg === "string") {
            this.showPopupError("error", msg);
          } else {
            this.showPopupError("error", "حدث خطأ غير متوقع");
          }
          //this.saveErrs.alert = true;
        });
    },

    send_request() {
      let payload = this.$store.state.request_info;
      let update_request = {
        request_id: parseInt(payload.id),
        customerName: payload.customer.name,
        sex: payload.customer.sex,
        birth_date: payload.customer.birth_date,
        birth_date_higri: payload.customer.birth_date_higri,
        age: payload.customer.age,
        age_years: payload.customer.age_years,
        work: payload.customer.work,
        madany_id: !payload.customer.askary_id
          ? parseInt(payload.customer.madany_id)
          : undefined,
        job_title: payload.customer.job_title,
        askary_id: !payload.customer.madany_id
          ? parseInt(payload.customer.askary_id)
          : undefined,
        military_rank: payload.customer.military_rank,
        hiring_date: payload.customer.hiring_date,
        salary: payload.customer.salary,
        salary_id: parseInt(payload.customer.salary_id),
        is_supported: payload.customer.is_supported,
        basic_salary: payload.customer.basic_salary,
        without_transfer_salary: payload.customer.without_transfer_salary,
        add_support_installment_to_salary:
          payload.customer.add_support_installment_to_salary,
        guarantees: parseInt(payload.customer.guarantees),
        has_obligations: payload.customer.has_obligations,
        obligations_value: payload.customer.obligations_value,
        has_financial_distress: payload.customer.has_financial_distress,
        financial_distress_value: payload.customer.financial_distress_value,
        jointName: payload.joint.name,
        jointMobile: payload.joint.mobile,
        jointSalary: payload.joint.salary,
        jointbirth: payload.joint.birth_date,
        jointBirth_higri: payload.joint.birth_date_higri,
        jointAge: payload.joint.age,
        jointage_years: payload.joint.age_years,
        jointWork: payload.joint.work,
        joint_hiring_date: payload.joint.hiring_date,
        jointmadanyWork: !payload.joint.jointaskaryWork
          ? parseInt(payload.joint.madany_id)
          : undefined,
        jointJobTitle: payload.joint.job_title,
        jointaskaryWork: !payload.joint.jointmadanyWork
          ? parseInt(payload.joint.askary_id)
          : undefined,
        jointRank: payload.joint.military_rank,
        jointsalary_source: parseInt(payload.joint.salary_id),
        jointSupport: payload.joint.is_supported,
        joint_add_support_installment_to_salary:
          payload.joint.add_support_installment_to_salary,
        jointObligations: payload.joint.has_obligations,
        jointobligations_value: payload.joint.obligations_value,
        jointfunding_source: parseInt(payload.joint.funding_id),
        realName: payload.real_estate.name,
        realMobile: payload.real_estate.mobile,
        realCity: payload.real_estate.city,
        project_id: payload.real_estate.project_id,
        realRegion: payload.real_estate.region,
        realPursuit: payload.real_estate.pursuit,
        realStatus: payload.real_estate.status,
        realAge: payload.real_estate.age,
        residence_type: payload.real_estate.residence_type,
        realType: payload.real_estate.type,
        realCost: payload.real_estate.cost,
        owning_property: payload.real_estate.owning_property,
        has_property: payload.real_estate.has_property,
        evaluated: payload.real_estate.evaluated,
        tenant: payload.real_estate.tenant,
        mortgage: payload.real_estate.mortgage,
        product_type: payload.funding.product_code,
        funding_source: payload.funding.funding_source,
        fundDur: payload.funding.funding_duration,
        fundPers: payload.funding.personalFun_cost,
        fundPersPre: payload.funding.personalFun_pre,
        fundReal: payload.funding.realFun_cost,
        fundRealPre: payload.funding.realFun_pre,
        fundFlex: payload.funding.flexiableFun_cost,
        fundExten: payload.funding.extendFund_cost,
        personal_salary_deduction: payload.funding.personal_salary_deduction,
        personal_installment: payload.funding.personal_monthly_installment,
        fundDed: payload.funding.ded_pre,
        fundMonth: payload.funding.monthly_in,
        installment_after_support: payload.funding.monthly_installment_after_support,
        reqtyp: payload.type,
        follow_date: payload.req_date,
        follow_time: payload.follow_time
          ? payload.follow_time.length == 8
            ? payload.follow_time
            : payload.follow_time + ":00"
          : undefined,
        reqSource: payload.source,
        class_agent: parseInt(payload.class_id_agent),
        rejection_id_agent: parseInt(payload.rejection_id_agent),
        collaborator_id: parseInt(payload.collaborator_id),
        comment: payload.agent_notes,
        customer_service_note: payload.customer_service_note,
        funding_manager_note: payload.funding_manager_note,
      };
      let update_payload = {};
      for (const prop in update_request) {
        if (update_request[prop] != null) {
          update_payload[prop] = update_request[prop];
        }
      }
      this.saveErrs = {
        alert: false,
        error: [],
      };
      Axios.post(
        `${this.$store.state.url}/agent/CheckRequestFieldsAndSendRequest`,
        update_payload,
        {
          headers: this.request_headers(),
        }
      )
        .then(() => {
          this.showPopup("success", "تم إرسال الطلب بنجاح");
          setTimeout(() => {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }, 2000);
        })
        .catch((err) => {
          // work here
          //this.saveErrs.error = [err.response.data.message];
          this.showPopupError("success", err.response.data.message);
          //this.saveErrs.alert = true;
        });
    },
  },
};
</script>
